import { useEffect, useMemo, useState } from 'react'
import { Grid, RadioGroup, FormControlLabel, Radio, Box, Tabs, Tab } from '@mui/material'
import { BaseGridLayout, ICONE, formattaData, capitalizza, BaseTesto, BaseBarraRicercaConRitardo, contieneTutteLeParole } from '@lucan/base-ui'
import { useVerbali } from 'configuration/ConfigurazioneApi'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { DATICONDUCENTE_ELENCO_VERBALI } from 'configuration/datiConducente'
import ConfigManager from 'components/config/ConfigManager'
import Testo from 'components/ui/Testo'
import ScatolaRisultatoRicerca from 'components/ui/ScatolaRisultatoRicerca'
import ChiaveValore from 'components/ui/ChiaveValore'
import Sezione from 'components/ui/Sezione'
import TitoloTab from 'components/ui/TitoloTab'
import { useDatiConducenteContext } from 'context/DatiConducenteProvider'
import Titoletto from 'components/ui/Titoletto'
import BadgeStatoDatiConducente from 'components/ui/datiConducente/BadgeStatoDatiConducente'
import LoadingPratiche from 'components/ui/LoadingPratiche'
import useSchermoStretto from 'hook/useSchermoStretto'
import { calcolaStatoDatiConducenteVerbale, SERVIZIO_DATI_CONDUCENTE, STATO_DATI_CONDUCENTE_VERBALE } from '../utilDatiConducente'

const CFG = DATICONDUCENTE_ELENCO_VERBALI

export default function ListaVerbaliWizard(props) {
  const { vaiAlVerbale, chiave } = props

  const {
    ScatolaMessaggi,
    getVerbali,
    inAttesaDelServer,
  } = useVerbali({ servizio: SERVIZIO_DATI_CONDUCENTE })

  const { salvaVerbale, listaVerbali, setListaVerbali } = useDatiConducenteContext()

  useEffect(() => {
    async function caricaVerbali() {
      const { ok, data } = await getVerbali()
      if (ok) {
        const { lista, messaggio } = data
        if (lista && !messaggio) {
          setListaVerbali(data.lista.reverse())
        }
      }
    }

    if (!listaVerbali) {
      caricaVerbali()
    }
  }, [])

  const verbaleScelto = (chiave) => {
    if (listaVerbali) {
      const findit = listaVerbali.find(({ chiave: c }) => chiave == c)
      if (findit) {
        salvaVerbale(findit.verbale)
      }
    }
    vaiAlVerbale(chiave)
  }

  return (
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_DATICONDUCENTE_ELENCO_VERBALI]}
      render={propsConfig => inAttesaDelServer ? (
        <LoadingPratiche testo={propsConfig.txt(CFG.CARICAMENTO)} />
      ) : (
        <>
          <Titoletto>{propsConfig.txt(CFG.TITOLO)}</Titoletto>
          <Testo sx={{ mb: 3 }}>{propsConfig.txt(CFG.SOTTOTITOLO)}</Testo>

          {ScatolaMessaggi}

          {listaVerbali &&
            <ListaVerbaliConRicerca
              listaVerbali={listaVerbali}
              vaiAlVerbale={verbaleScelto}
              chiave={chiave}
              propsConfig={propsConfig}
            />
          }
        </>
      )}
    />
  )
}



function ListaVerbaliConRicerca(props) {
  const { listaVerbali, vaiAlVerbale, propsConfig, chiave } = props
  const { val, txt } = propsConfig

  const [ricerca, setRicerca] = useState('')
  const [ricercaStato, setRicercaStato] = useState(null)

  const counterVerbali = useMemo(() => {
    return listaVerbali.reduce(
      (acc, v) => {
        const stato = calcolaStatoDatiConducenteVerbale(v?.verbale)

        acc.tot += 1

        if (stato === STATO_DATI_CONDUCENTE_VERBALE.MODULO_DA_COMPILARE) {
          acc.daCompilare += 1
        } else if (stato === STATO_DATI_CONDUCENTE_VERBALE.MODULO_RICEVUTO) {
          acc.ricevuti += 1
        }

        return acc
      },
      { tot: 0, daCompilare: 0, ricevuti: 0 }
    )
  }, [listaVerbali])

  const listaVerbaliFiltrata = useMemo(() => {
    return listaVerbali.filter(({ verbale }) => {
      if (ricercaStato) {
        const stato = calcolaStatoDatiConducenteVerbale(verbale)
        if (stato != ricercaStato) {
          return false
        }
      }

      if (!ricerca) return true

      const {
        numero_verbale,
        infrazione_data,
        contestazione_data,
        procedura,
      } = verbale

      const infoConcatenate = [
        procedura,
        numero_verbale,
        formattaData(infrazione_data),
        formattaData(contestazione_data)
      ].join(' ')
      return contieneTutteLeParole(infoConcatenate, ricerca)
    })
  }, [listaVerbali, ricerca, ricercaStato])

  const schermoStretto = useSchermoStretto()

  const tabs = [
    {
      value: null,
      icona: ICONE.DESCRIZIONE,
      titolo: `${val(CFG.TABS_TUTTI)}: ${counterVerbali.tot}`,
    }, {
      value: STATO_DATI_CONDUCENTE_VERBALE.MODULO_DA_COMPILARE,
      icona: ICONE.MODIFICA,
      titolo: `${val(CFG.TABS_DA_COMPILARE)}: ${counterVerbali.daCompilare}`,
    }, {
      value: STATO_DATI_CONDUCENTE_VERBALE.MODULO_RICEVUTO,
      icona: ICONE.SALVA,
      titolo: `${val(CFG.TABS_RICEVUTI)}: ${counterVerbali.ricevuti}`,
    },
  ]

  const handleChange = (event, newValue) => {
    setRicercaStato(newValue)
  }

  return (
    <>
      {listaVerbali.length > 0 &&
        <BaseGridLayout vertical noWrap spacing={3}>
          <Sezione>
            <Box>
              <BaseBarraRicercaConRitardo
                label={val(CFG.PLACEHOLDER_RICERCA)}
                setTestoRicerca_FinitoDiScrivere={setRicerca}
                messaggioAiuto=''
                numeroMinimoCaratteriRicerca={1}
                larghezza={schermoStretto ? 'fullWidth' : 30}
              />
              <Tabs
                variant='fullWidth'
                value={ricercaStato}
                onChange={handleChange}
                indicatorColor='primary'
              >
                {tabs.map(({ titolo, icona, value }, indice) =>
                  <Tab
                    label={<TitoloTab Icona={icona} titolo={titolo} />}
                    value={value}
                    key={indice}
                  />
                )}
              </Tabs>
            </Box>

            <RadioGroup
              value={chiave}
              sx={{ flexWrap: 'noWrap', maxHeight: '40vh', overflow: 'auto' }}
              onChange={e => vaiAlVerbale(e.target.value)}
            >
              <Box>
                {listaVerbaliFiltrata.map(verbale => (
                  <Box key={verbale.chiave} sx={{ width: '100%', bgcolor: '#fff', m: 0, p: 2, marginBottom: '1px' }}>
                    <FormControlLabel
                      slotProps={{
                        typography: {
                          sx: { width: '100%' }, // stile della label
                        },
                      }}
                      sx={{ width: '100%' }}
                      value={verbale.chiave}
                      control={<Radio />}
                      label={
                        <ScatolaVerbale
                          verbale={verbale}
                          vaiAlVerbale={vaiAlVerbale}
                          key={verbale.chiave}
                          {...propsConfig}
                        />
                      }
                    />
                  </Box>
                ))}
              </Box>
            </RadioGroup>
          </Sezione>
        </BaseGridLayout>
      }

      {listaVerbaliFiltrata.length === 0 &&
        <BaseTesto>{txt(CFG.NESSUN_VERBALE_TROVATO)}</BaseTesto>
      }
    </>
  )
}



function ScatolaVerbale(props) {
  const { verbale, txt } = props
  const {
    verbale: {
      numero_verbale,
      infrazione_data,
      contestazione_data,
      procedura,
    }
  } = verbale

  return (
    <ScatolaRisultatoRicerca
      Icona={ICONE.DESCRIZIONE}
      titolo={`${capitalizza(procedura)} ${numero_verbale}`}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} lg={4}>
          <ChiaveValore
            chiave={txt(CFG.DATA_INFRAZIONE)}
            valore={formattaData(infrazione_data)}
          />
        </Grid>

        <Grid item xs={12} sm={6} lg={4}>
          <ChiaveValore
            chiave={txt(CFG.DATA_CONTESTAZIONE)}
            valore={formattaData(contestazione_data)}
          />
        </Grid>

        <Grid item xs={12} sm={12} lg={4}>
          <BadgeStatoDatiConducente verbale={verbale.verbale} />
        </Grid>
      </Grid>
    </ScatolaRisultatoRicerca>
  )
}